export { default } from "./EditUserModal";

